<!-- 时间选择 -->
<template>
  <div class="TimeSelect">
    <!-- 保存当天模板 -->
    <el-dialog
      :title="MoveandCopyTime.type"
      :visible.sync="MoveandCopyTime.show"
      width="600px"
    >
      <div class="BoyContent">
        <div class="title"><span>*</span> {{ $t('lang.startFrom') }}</div>
        <div class="selectTime">
          <el-date-picker
            type="datetime"
            v-model="StartFrom"
            popper-class="pick_date_time"
            :picker-options="pickerDateStart"
            :placeholder="$t('lang.selectData')"
            value-format="timestamp"
            format="yyyy-MM-dd h:mm:ss A"
          >
          </el-date-picker>
        </div>
      </div>
      <div
        slot="footer"
        class="dialog-footer">
        <el-button @click="MoveandCopyTime.show = false">{{
          $t("lang.cancel")
        }}</el-button>
        <el-button
          type="primary"
          @click="ApplyTime">{{
            $t("lang.apply")
          }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Outil from '@/assets/js/utils.js'
export default {
  props: {
    MoveandCopyTime: {
      type: Object,
      default: () => ({
        type: 'Move',
        show: false
      })
    }
  },
  data () {
    return {
      StartFrom: new Date().getTime(),
      //   时间选择限制
      pickerDateStart: {
        disabledDate (time) {
          var date = Outil.getDateTime()
          return (
            time.getTime() <
            new Date(`${date.year}-${date.month}-${date.day} 00:00:00`).getTime()
          )
        }
      }
    }
  },
  created () {},
  mounted () {},
  methods: {
    ApplyTime () {
      this.$emit('ApplyStartFrom', this.StartFrom)
    }
  }
}
</script>

<style scoped lang="less">
.TimeSelect {
  .BoyContent {
    text-align: left;
    .title {
      color: #fff;
      span {
        color: #f56c6c;
      }
    }
    .selectTime {
      margin-top: 10px;
      ::v-deep.el-input__inner {
        width: 520px;
        height: 40px;
        padding-left: 10px;
        border: none;
        color: #dfdfdf;
        background: #444;
      }
      ::v-deep .el-input__prefix {
        .el-icon-time{
          display: none;
        }
      }
    }
  }
  ::v-deep.el-dialog__footer {
    padding: 10px 20px 30px;
    .dialog-footer {
      text-align: right;
    }
  }
}
</style>
